import { Component, ContentChild, Input } from '@angular/core';

@Component({
  selector: 'waypoint',
  templateUrl: 'waypoint.html',
})
export class WaypointComponent {
  @ContentChild('waypoint') waypointTemplate;
  @ContentChild('default') defaultTemplate;
  @Input() scrollCloseThreshold;
  canShow = false;

  constructor() {}
}



// WEBPACK FOOTER //
// ./src/components/waypoint/waypoint.ts